// routes
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const CAPTCHA_API = process.env.REACT_APP_CAPTCHA_API;
export const ATTACHMENT_API = process.env.REACT_APP_ATTACHMENT_API;
export const ANDROID_URL = process.env.REACT_APP_ANDROID_URL;
export const WS_API = process.env.REACT_APP_WS_API;
export const GOCAPTCHA_SITE_KEY = process.env.REACT_APP_GOCAPTCHA_SITE_KEY;

export const ASSETS_API = process.env.REACT_APP_ASSETS_API;
export const FILE_ATTACHMENT_FORMATS = process.env.REACT_APP_FILE_ATTACHMENT_FORMATS;
export const IMAGE_ATTACHMENT_FORMATS = process.env.REACT_APP_IMAGE_ATTACHMENT_FORMATS;

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;
export const MAPBOX_LIGHT_URL = process.env.REACT_APP_MAPBOX_LIGHT_URL;
export const MAPBOX_DARK_URL = process.env.REACT_APP_MAPBOX_DARK_URL;

export const ATTACHMENT_URL = `${ATTACHMENT_API}`;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const ADMIN_PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'
export const USER_PATH_AFTER_LOGIN = '/chatbot'; // as '/profile'

// ----------------------------------------------------------------------

export const NAV_WIDTH = 265;
export const NAV_MOBILE_WIDTH = NAV_WIDTH + 25;
export const NAV_COLLAPSE_WIDTH = 60;

export const MINIMUM_TEXT_TOKENS = 100;
export const MINIMUM_IMAGE_TOKENS = 2000;
export const IMAGE_CAPACITY = 20; // image count: 10
